import slugify from 'client/util/slugify';

const getLink = ({ _id, addName, name }) => {
  return `${window.location.origin}/l/${_id}${addName ? `/n/${slugify(name)}` : ''}`;
};
export default getLink;
